
exports.data = [
    {
        id:1,
        title:'PLC Programing',
        description:`A programmable logic controller (PLC) or programmable controller is an industrial
         computer that has been ruggedized and adapted for the control of manufacturing processes, such 
         as assembly lines, machines, robotic devices, or any activity that requires high reliability, 
         ease of programming, and process fault diagnosis.
        `,
        Image:require('./Measuring/PLC.jpg')

    },
    {
        id:2,
        title:'HMI Programing',
        description:`A Human-Machine Interface (HMI) is a user interface that allows humans to interact
         with and control machines, systems, or devices, often used in industrial settings to monitor, 
         control, and manage processes. 
        `,
        Image:require('./Measuring/HMI.jpeg')

    },
    {
        id:3,
        title:'SCADA Programing',
        description:`SCADA, which stands for Supervisory Control and Data Acquisition, is a system used
         for monitoring and controlling industrial processes, collecting real-time data from various
          sensors and devices, and enabling remote control of equipment. 
        `,
        Image:require('./Measuring/Scada.png')

    },
    {
        id:4,
        title:'SQL DataBase Reporting',
        description:`SQL data reporting is the process of data exploration, cleaning and validation, 
        and performing complex calculations on relational databases using SQL.
        `,
        Image:require('./Measuring/SQL.png')

    },
    {
        id:5,
        title:'Web Development',
        description:`Web development encompasses the process of building, programming, and maintaining websites and web applications
        `,
        Image:require('./Measuring/web.jpeg')

    },
    {
        id:6,
        title:'Software Development',
        description:`Software development is the process of designing, building, testing, and maintaining software applications, 
        involving computer science, engineering, and mathematical principles to create efficient, reliable, and user-friendly software. 
        `,
        Image:require('./Measuring/Software-Development.jpg')

    },
    {
        id:7,
        title:'Data Intigration',
        description:`Data integration is the process of combining data from multiple sources into a unified, usable format, enabling 
        organizations to gain a comprehensive view of their data for better analysis, decision-making, and business intelligence. 
        `,
        Image:require('./Measuring/Data_Integration.png')

    }
]